import {IExpensesResponse} from "../../api/expenseService";

export interface IExpenseState {
    items: IExpensesResponse
    fetchExpensesLoading: boolean
    actionLoading: boolean
    fetchExpensesRequestId?: string
}

export const initialExpensesState: IExpensesResponse = {
    total_pages: 0,
    count: 0,
    data: [],
}
